export default __webpack_public_path__ + "guide--raster-rasters-are-pixels-480-390cef3d46f577385c8229fa30adbf71.png";